export default __webpack_public_path__ + "assets/images/1.85edc7.webp";